import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import Icon from "../../../../../../../base/icons/icon/index.js";
import Image from "../../../../../../../base/multimedia/image/index.js";
import { getIconTransport } from "../../../../utils/index.js";
import * as S from "./styled.js";
const CityInfo = ({ city , className  })=>/*#__PURE__*/ _jsxs(S.CityInfo, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("li", {
                className: "travel-date",
                children: city.date
            }),
            /*#__PURE__*/ _jsx("li", {
                className: "travel-hour",
                children: city.hour
            }),
            /*#__PURE__*/ _jsx("li", {
                className: "travel-code",
                children: city.city
            })
        ]
    });
const CardTransport = ({ outbound , arrival , product ='TRAINHOTEL'  })=>{
    const travelInfo = [
        outbound,
        arrival
    ];
    const icon = getIconTransport(product);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "CardTransport",
        children: Children.toArray(travelInfo.map((travel)=>/*#__PURE__*/ _jsx(S.Travel, {
                children: /*#__PURE__*/ _jsxs(S.CardTravel, {
                    children: [
                        /*#__PURE__*/ _jsx(CityInfo, {
                            className: "card-travel-origin",
                            city: travel.origin
                        }),
                        /*#__PURE__*/ _jsxs(S.TransportInfo, {
                            children: [
                                travel.info.fare && /*#__PURE__*/ _jsx("p", {
                                    children: travel.info.fare
                                }),
                                travel.info.type && /*#__PURE__*/ _jsx("p", {
                                    children: travel.info.type
                                }),
                                /*#__PURE__*/ _jsx(S.Divider, {
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        "data-testid": "CardTransportIcon",
                                        className: `nico-${icon}`
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Image, {
                                    alt: travel.info.company,
                                    src: travel.info.logo
                                }),
                                travel.info.company && /*#__PURE__*/ _jsx("span", {
                                    children: travel.info.company
                                }),
                                travel.info.reference && /*#__PURE__*/ _jsx("span", {
                                    children: travel.info.reference
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(CityInfo, {
                            className: "card-travel-destination",
                            city: travel.destination
                        })
                    ]
                })
            })))
    });
};
export default CardTransport;

//# sourceMappingURL=index.js.map